// extracted by mini-css-extract-plugin
export default {"root":"CustomerManagersCard_root__snq2r"};